import { render, staticRenderFns } from "./ReceptionContent.vue?vue&type=template&id=30d588ce&scoped=true&"
import script from "./ReceptionContent.vue?vue&type=script&lang=ts&"
export * from "./ReceptionContent.vue?vue&type=script&lang=ts&"
import style0 from "./ReceptionContent.vue?vue&type=style&index=0&id=30d588ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d588ce",
  null
  
)

export default component.exports